export const REQUEST_ALL_EVENTS = 'events/REQUEST_ALL';
export const REQUEST_EVENT_DETAILS = 'events/REQUEST_DETAILS';

export const SET_ALL_EVENTS = 'events/SET_ALL';
export const SET_EVENT_DETAILS = 'events/SET_DETAILS';
export const SET_EVENTS_DATE = 'events/SET_DATE';

export const RESET_ALL_EVENTS = 'events/RESET_ALL';
export const RESET_EVENT_DETAILS = 'events/RESET_EVENTS_DETAILS';
